import React, { useMemo } from 'react';
import _ from 'lodash';
import GenericPullConfigListing from '../GenericPullConfigListing'
import FiniteStateCredentialsForm from './FiniteStateCredentialsForm'
import FiniteStateMappingForm from './FiniteStateMappingForm'
import { columnRenderArrayData } from 'utils/tableUtils';
import { Typography } from 'antd';

export default function FiniteStateConfigListing(props) {

    const columns = [
        {
            title: "FiniteState Artifacts",
            dataIndex: "projectName",
            width: 160
        },
        {
            title: "Firmware Version",
            dataIndex: "firmwareName",
            width: 160,
            render: columnRenderArrayData
        }
    ];

    const extraLoginConfigFields = useMemo(() => {
        return _.map(props.loginConfigList, (list) => {
            return list.orgName ? <Typography.Text className="m-r-l">Portfolio: {list.orgName}</Typography.Text> : null
        });
    }, [props.loginConfigList]);

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={FiniteStateMappingForm}
            CredentialsForm={FiniteStateCredentialsForm}
            extraLoginConfigFields={extraLoginConfigFields}
            extraColumns={columns}
        />
    )
}